import React, { useCallback } from "react";

import { Button } from "@/components/form/Button/Button";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { Paper } from "@/components/paper/Paper";
import { useAuthContext } from "@/context/auth-renderer/Auth.context";
import useChatWindow from "@/hooks/useChatOpen";
import { useOpenRegisterModal } from "@/hooks/useOpenRegisterModal";
import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = {
  ladyId?: number;
  isOnline?: boolean;
};

export const PrivatePhotoAttachment: React.FC<PropTypes> = ({
  isOnline,
  ladyId,
}) => {
  const authContext = useAuthContext();
  const { openModalWithHeader } = useOpenRegisterModal();

  const { openModal: MailBoxOpenModal } = useOpenModal({
    disableBackGroundClick: true,
  });

  const openChatWindow = useChatWindow(ladyId);
  const handleOnOkClickAuth = useCallback(() => {
    if (isOnline) {
      openChatWindow("liveChat");
    } else {
      MailBoxOpenModal("CREATE_LETTER_MODAL", {
        ladyId: ladyId,
      });
    }
  }, [isOnline, MailBoxOpenModal, ladyId, openChatWindow]);

  const buttonText = authContext.isAuthenticated
    ? isOnline
      ? "Live Chat"
      : "Write a letter"
    : "Sign in";

  const onClick = authContext.isAuthenticated
    ? handleOnOkClickAuth
    : openModalWithHeader("to Continue", true);

  return (
    <div
      data-testid="privatePhotoAttachment"
      className="absolute inset-0 flex flex-col items-center justify-center text-center"
    >
      <Paper className={clsxm("p-3 w-[265px] border-t-4 border-green-600")}>
        <h2 className="text-base font-bold mb-[8px]">Information!</h2>
        {authContext.isAuthenticated ? (
          <div>
            <p className="text-sm">
              You can see the Private Photo if you make contact with this
              member.
            </p>
            <p className="text-sm my-3">
              Write a letter or start chatting right now via Live Chat
            </p>
          </div>
        ) : (
          <div>
            <p className="text-sm my-3">
              Register to view the Private Photo. Access unlocks after you
              contact this woman via letter or Live Chat.
            </p>
          </div>
        )}

        <Button
          variant="primary"
          onHoverVariant="gradient-flip"
          className="w-2/3 text-sm"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </Paper>
    </div>
  );
};
